import { TextInput, TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';

const Content = () => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched, submitCount } = formikContext;

  const _errors = {
    senhaAtual: (submitCount > 0 || touched?.senhaAtual) && errors?.senhaAtual,
    novaSenha: (submitCount > 0 || touched?.novaSenha) && errors?.novaSenha,
    confirmarNovaSenha: (submitCount > 0 || touched?.confirmarNovaSenha) && errors?.confirmarNovaSenha,
  };

  return (
    <>
      <div className="h-full max-h-full w-full">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextLabel label="Nome" value={values?.nome} />
          </Grid>

          <Grid item xs={12}>
            <TextLabel label="E-mail" value={values?.email} />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              id="senhaAtual"
              label="Senha atual"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values?.senhaAtual}
              touched={!!_errors.senhaAtual}
              error={_errors.senhaAtual}
              maxLength={20}
              type="password"
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              id="novaSenha"
              label="Nova senha"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values?.novaSenha}
              touched={!!_errors.novaSenha}
              error={_errors.novaSenha}
              maxLength={20}
              type="password"
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              id="confirmarNovaSenha"
              label="Confirme a nova senha"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values?.confirmarNovaSenha}
              touched={!!_errors.confirmarNovaSenha}
              error={_errors.confirmarNovaSenha}
              maxLength={20}
              type="password"
              required
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Content;
